import { render, staticRenderFns } from "./AllCustomerDialog.vue?vue&type=template&id=4db672f2&scoped=true&"
import script from "./AllCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./AllCustomerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomerDialog.vue?vue&type=style&index=0&id=4db672f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db672f2",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QIcon,QBtn,QList,QItem,QItemSection,QAvatar,QItemLabel});qInstall(component, 'directives', {ClosePopup});
